import React, { useEffect, useState } from "react";
import { DateTime } from "luxon";
import {
  amountFormatter,
  useCountdown,
  getAllWrongBidsForBanker,
  getAllBidsForBanker,
  useCountdownOld,
  getAllBidsForAdmin_AuctionFloor,
  getAllWrongBidsForAdmin_AuctionFloor,
  getAuctionEventStatusByIdForAdmin_AuctionFloor,
} from "services";
import BidsHistory from "./events/BidsHistory";
import { ModalBase } from "@reusejs/react";

export default function BankerEventData(props: any) {
  const [hours, minutes, seconds, isTimeEnded] = useCountdownOld(props.endTime);

  const openModal = async (correctBids: any, wrongBids: any) => {
    const correctBidsData: any =
      process.env.NEXT_PUBLIC_APP_NAME === "banker"
        ? await getAllBidsForBanker(props.data.uuid)
        : await getAllBidsForAdmin_AuctionFloor(props.data.uuid);
    const wrongBidsData: any =
      process.env.NEXT_PUBLIC_APP_NAME === "banker"
        ? await getAllWrongBidsForBanker(props.data.uuid)
        : await getAllWrongBidsForAdmin_AuctionFloor(props.data.uuid);

    const BidsHistoryModalWrapper = (props: any) => {
      return (
        <BidsHistory
          correctBids={correctBidsData}
          userWrongBids={wrongBidsData}
          type="live"
          {...props}
        />
      );
    };

    await ModalBase(
      {
        content: BidsHistoryModalWrapper,
        timeout: 0,
        backgroundColor: "bg-black/30",
        backgroundOpacity: "opacity-70",
        modalBaseClasses: {
          background: "bg-white",
          border: "border-2 rounded-lg",
          alignment: "text-left overflow-visible",
          padding: "p-0",
          small: "w-full sm:max-w-4xl",
        },
      },
      1000,
      "__next",
    );
  };

  const handleBidsHistory = () => {
    openModal(props.correctBids, props.wrongBids);
  };
  const checkBidStatus = async (checkStatus = 0) => {
    console.log("isTimeEnded inside checkBidStatus", isTimeEnded, checkStatus);
    if (isTimeEnded || checkStatus) {
      try {
        setTimeout(async () => {
          const res: any = await getAuctionEventStatusByIdForAdmin_AuctionFloor(
            props.data.uuid,
          );
          if (res?.status && res?.status === "end") {
            console.log("status came as end", res?.status);
            props.setStatus(res?.status);
          }
        }, 1000);
      } catch (error) {
        console.log("error", error);
      }
    }
  };

  useEffect(() => {
    console.log("isTimeEnded::>", isTimeEnded);
    (async () => {
      await checkBidStatus(isTimeEnded);
    })();
  }, [isTimeEnded]);
  return (
    <>
      <div className="py-2">
        <div className="overflow-hidden bg-white shadow sm:rounded-lg">
          <div className="px-4 py-5 sm:px-6">
            <div className="flex justify-between items-center">
              <h3 className="text-lg font-medium leading-6 text-gray-900">
                Auction Event, ID: {props.data?.listing_id}
                {/* <p className="mt-1 text-xs text-gray-500">
                  Connection Status:{" "}
                  <span
                    className={`font-bold ${
                      props.connectionStatus === "Online"
                        ? "text-green-500"
                        : props.connectionStatus === "Offline"
                        ? "text-red-500"
                        : "text-yellow-500"
                    }`}
                  >
                    {props.connectionStatus}
                  </span>
                </p>
                {props.connectionStatus === "Connecting" && (
                  <p className="text-sm font-medium leading-6 text-yellow-500">
                    {
                      "Slow Connection Alert! Ensure you're connected to stable network connection. Refresh the page for accurate bidding status"
                    }
                  </p>
                )} */}
              </h3>
              {/* {props.connectionStatus === "Online" && ( */}
              <div className="flex flex-col w-20 justify-center items-center">
                {props.status === "live" && (
                  <span className="inline-flex w-16 items-center rounded-full bg-green-100 px-2.5 py-0.5 text-xs font-medium text-green-800">
                    <svg
                      className="-ml-0.5 mr-1.5 h-2 w-2 text-green-400"
                      fill="currentColor"
                      viewBox="0 0 8 8"
                    >
                      <circle cx={4} cy={4} r={3} />
                    </svg>
                    Live
                  </span>
                )}
                {props.status === "end" && (
                  <span className="inline-flex w-16 items-center rounded-full bg-red-100 px-2.5 py-0.5 text-xs font-medium text-red-800">
                    <svg
                      className="-ml-0.5 mr-1.5 h-2 w-2 text-red-400"
                      fill="currentColor"
                      viewBox="0 0 8 8"
                    >
                      <circle cx={4} cy={4} r={3} />
                    </svg>
                    Ended
                  </span>
                )}
                <div
                  className={
                    "mt-2 text-lg sm:col-span-2 " +
                    `${
                      props.status === "live" &&
                      props.endTime &&
                      props.endTime -
                        DateTime.now().setZone("Asia/Kolkata").toMillis() <=
                        parseInt(props.data?.extend_time_at) * 60 * 1000
                        ? "text-red-600 font-semibold"
                        : "text-gray-900 font-medium"
                    }`
                  }
                >
                  {props.status === "live"
                    ? hours < 10
                      ? `0${hours}`
                      : hours
                    : "00"}
                  :
                  {props.status === "live"
                    ? minutes < 10
                      ? `0${minutes}`
                      : minutes
                    : "00"}
                  :
                  {props.status === "live"
                    ? seconds < 10
                      ? `0${seconds}`
                      : seconds
                    : "00"}
                </div>
              </div>
              {/* )} */}
            </div>
            <p className="mt-1 max-w-2xl text-sm text-gray-500">
              Latest Bid Price:
              <span className="font-bold text-gray-900">
                {props.latestBid
                  ? `₹ ${amountFormatter(props.latestBidAmount)}`
                  : "NA"}
              </span>{" "}
              at{" "}
              {props.status !== "end"
                ? `${props.currentTime} (IST)`
                : props.latestBid?.bid_timestamp &&
                  `${DateTime.fromMillis(
                    typeof props.endTime === "string"
                      ? parseInt(props.endTime)
                      : props.endTime,
                    // typeof props.latestBid?.bid_timestamp === "string"
                    //   ? parseInt(props.latestBid?.bid_timestamp)
                    //   : props.latestBid?.bid_timestamp
                  )
                    .setZone("Asia/Kolkata")
                    .toFormat("DD hh:mm:ss a")} (IST)`}
            </p>
            {/* {props.latestBid && (
              <p className="mt-1 max-w-2xl text-sm text-gray-500">
                H1:{" "}
                <span className="font-medium text-gray-900">
                  ₹ {amountFormatter(props.latestBid?.bidding_amount)}
                </span>{" "}
                at{" "}
                {props.latestBid?.bid_timestamp &&
                  `${DateTime.fromMillis(
                    typeof props.latestBid?.bid_timestamp === "string"
                      ? parseInt(props.latestBid?.bid_timestamp)
                      : props.latestBid?.bid_timestamp
                  )
                    .setZone("Asia/Kolkata")
                    .toFormat("DD hh:mm a")} (IST)`}
              </p>
            )}
            {props.prevBid && (
              <p className="mt-1 max-w-2xl text-sm text-gray-500">
                H2:{" "}
                <span className="font-medium text-gray-900">
                  ₹ {amountFormatter(props.prevBid?.bidding_amount)}
                </span>{" "}
                at{" "}
                {props.prevBid?.bid_timestamp &&
                  `${DateTime.fromMillis(
                    typeof props.prevBid.bid_timestamp === "string"
                      ? parseInt(props.prevBid?.bid_timestamp)
                      : props.prevBid?.bid_timestamp
                  )
                    .setZone("Asia/Kolkata")
                    .toFormat("DD hh:mm a")} (IST)`}
              </p>
            )} */}
            <div className="flex justify-end">
              <span
                className="text-sm hover:text-blue-600 cursor-pointer"
                onClick={() => handleBidsHistory()}
              >
                Bids History
              </span>
            </div>
          </div>

          <div className="border-t border-gray-200 px-4 py-5 sm:p-0">
            <dl className="sm:divide-y sm:divide-gray-200">
              <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  Next Possible Bid
                </dt>
                <dd className="mt-1 text-sm text-gray-900 font-semibold sm:col-span-2 sm:mt-0">
                  {props.latestBidAmount
                    ? typeof props.latestBidAmount === "string"
                      ? `₹ ${amountFormatter(
                          parseInt(props.latestBidAmount) +
                            parseInt(props.data?.bidding_increment_amount),
                        )}`
                      : `₹ ${amountFormatter(
                          props.latestBidAmount +
                            parseInt(props.data?.bidding_increment_amount),
                        )}`
                    : "₹ 00"}
                </dd>
              </div>
              <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  Reserve Price
                </dt>
                <dd className="mt-1 text-sm text-gray-900 font-medium sm:col-span-2 sm:mt-0">
                  ₹ {amountFormatter(props.data?.reserve_price)}
                </dd>
              </div>
              <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  Increment Price By
                </dt>
                <dd className="mt-1 text-sm text-gray-900 font-medium sm:col-span-2 sm:mt-0">
                  ₹ {amountFormatter(props.data?.bidding_increment_amount)}
                </dd>
              </div>

              <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  {props.status === "end" ? "Ended At" : "Ends At"}
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                  {props.endTime
                    ? `${DateTime.fromMillis(props.endTime)
                        .setZone("Asia/Kolkata")
                        .toFormat("DD hh:mm:ss a")} (IST)`
                    : "00"}
                </dd>
              </div>
              <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  {props.status === "live" ? "Started At" : "Starts At"}
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                  {props.startTime
                    ? `${DateTime.fromMillis(props.startTime)
                        .setZone("Asia/Kolkata")
                        .toFormat("DD hh:mm:ss a")} (IST)`
                    : "00"}
                </dd>
              </div>
              <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  Number of Extension
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                  {props.latestBid?.number_of_extension
                    ? props.latestBid?.number_of_extension
                    : "0"}
                </dd>
              </div>
            </dl>
          </div>
        </div>
      </div>

      <div className="py-2">
        <div className="overflow-hidden bg-white shadow sm:rounded-lg">
          <div className="px-4 py-5 sm:px-6">
            <h3 className="text-lg font-medium leading-6 text-gray-900">
              Auction Details
            </h3>
            {/* <p className="mt-1 max-w-2xl text-sm text-gray-500">
              Property Details -
            </p> */}
          </div>

          <div className="border-t border-gray-200 px-4 py-5 sm:p-0">
            <dl className="sm:divide-y sm:divide-gray-200">
              <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  Auction Brief
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                  {props.data?.event_name}
                </dd>
              </div>
              <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  EMD Amount
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                  ₹ {amountFormatter(props.data?.property_dump?.emd_amount)}
                </dd>
              </div>
              <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  Actual Start Time
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                  {`${DateTime.fromISO(props.data?.start_date_time)
                    .setZone("Asia/Kolkata")
                    .toFormat("DD hh:mm a")} (IST)`}
                </dd>
              </div>
              <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  Actual End Time
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                  {`${DateTime.fromISO(props.data?.end_date_time)
                    .setZone("Asia/Kolkata")
                    .toFormat("DD hh:mm a")} (IST)`}
                </dd>
              </div>
              <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  Extension Type
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                  {props.data?.auto_extension_type}
                </dd>
              </div>
              <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  Extension At
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                  Last{" "}
                  <span className="font-semibold">
                    {props.data?.extend_time_at}
                  </span>{" "}
                  minutes
                </dd>
              </div>
              <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  Extension By
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                  <span className="font-semibold">
                    {props.data?.extend_time_by}
                  </span>{" "}
                  minutes
                </dd>
              </div>
            </dl>
          </div>
        </div>
      </div>
    </>
  );
}
